<template>
    <div class="main-content">

        <customModal v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="acceptModal"
                     :modalData="modalData"></customModal>

        <div class="card">
            <div class="card-header">
                <h5 class="inline">Объединенные ЕГК коды</h5> <span
                    v-if="paginator">Всего: <strong>{{paginator.total}}</strong></span>
            </div>
            <div class="card-body">
                <div class="row search_row">
                    <div class="col-md-3">
                        <button type="button" @click="resetCodes" class="btn btn-info">Обновить</button>
                    </div>
                    <div class="col-md-5">
                        <div class="alert alert-info m-b-0">
                            Все search слова (сочитание слов) разделяются запятой (",")
                        </div>
                    </div>
                    <div class="col-md-4">
                        <form action="" @submit="searchSubmit">
                            <div class="input-group">
                                <input type="text" placeholder="Поиск..." v-model="search" class="form-control">
                                <div class="input-group-prepend">
                                    <button type="submit" class="btn btn-success">Поиск</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row" v-if="parser">
                    <div class="col-md-12 m-b-10">
                        Обновление статистики: <strong>{{parser.created_at}}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">

                <div>
                    <div class="row filter">
                        <div class="col-md-4">
                            <h6>Предложения на aptekamos</h6>
                            <!--                            <div class="form-group" id="data_5">-->
                            <!--                                <div class="input-group input-group-sm my-2" id="datepicker">-->
                            <!--                                    <input type="date" class="form-control" name="start_date" value="2019-01-03" max="2019-01-04">-->
                            <!--                                    <div class="input-group-prepend input-group-append">-->
                            <!--                                        <span class="input-group-text">to</span>-->
                            <!--                                    </div>-->
                            <!--                                    <input type="date" class="form-control" name="end_date" value="2019-01-03" max="2019-01-04">-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div class="form-group m-b-0">
                                <div class="input-group input-group-sm">
                                    <input v-model="filter.stat.from" type="number" class="form-control"
                                           placeholder="От...">
                                    <div class="input-group-prepend input-group-append">
                                        <span class="input-group-text">to</span>
                                    </div>
                                    <input v-model="filter.stat.to" type="number" class="form-control"
                                           placeholder="До...">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h6>WordStat статистика запросов</h6>
                            <div class="form-group m-b-0">
                                <div class="input-group input-group-sm">
                                    <input v-model="filter.word.from" type="number" class="form-control"
                                           placeholder="От...">
                                    <div class="input-group-prepend input-group-append">
                                        <span class="input-group-text">to</span>
                                    </div>
                                    <input v-model="filter.word.to" type="number" class="form-control"
                                           placeholder="До...">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" style="align-self: flex-end;">
<!--                            <button @click="refreshCodes" class="btn btn-sm btn-success">Фильтровать</button>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div>
            <form action="">

                <codesTable ref="recordsTable" :updateSort="updateSort" :filter="filter" :tableRecords="records"
                            tableType="grouped"/>

                <div class="text-right">
                    <paginate v-if="paginator"
                              :page-count="paginator.last_page"
                              ref="Pagination"
                              :page-range="11"
                              :margin-pages="2"
                              :click-handler="getRecords"
                              :prev-text="'&laquo'"
                              :next-text="'&raquo'"
                              :container-class="'pagination'"
                              :prev-class="'page-item'"
                              :prev-link-class="'page-link'"
                              :page-class="'page-item'"
                              :page-link-class="'page-link'"
                              :next-class="'page-item'"
                              :next-link-class="'page-link'"
                              :active-class="'active green_btn'">
                    </paginate>
                    <div>
                        <button type="button" @click="moderateSelected" class="btn btn-success">Добавить в модерированные
                        </button>
                        <button type="button" @click="clearGroup" class="btn btn-info">Игнорировать для парсинга
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import Paginate from 'vuejs-paginate'
    import customModal from '@/components/modals/customModal'
    import codesTable from '@/components/egk/codesTable'


    export default {
        components: {
            Paginate,
            customModal,
            codesTable,
        },
        data() {
            return {
                Toast: this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }),
                filter: {
                    sorting: 0,
                    sorting_type: 'name',
                    stat: {
                        from: null,
                        to: null
                    },
                    word: {
                        from: null,
                        to: null
                    }
                },
                records: null,
                currentPage: 1,
                paginator: null,
                search: null,
                modalData: null,
                parser: null,
            }
        },
        mounted() {
            this.getRecords()
        },
        methods: {
            moderateSelected(){
                let codes = [];

                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    if (el.checked) codes.push(el.name);
                });

                if (!codes.length) return;

                this.modalData = {
                    codes: codes,
                    type: 'moderate',
                    header: 'Модерирование',
                    body: 'Хотите добавить выбранные продукты в модерированные?',
                    acceptBtnText: 'Да',
                    cancelBtnText: 'Нет'
                };
            },
            resetCodes() {
                this.filter = {
                    sorting: 0,
                    sorting_type: 'name',
                    stat: {
                        from: null,
                        to: null
                    },
                    word: {
                        from: null,
                        to: null
                    }
                };
                this.refreshCodes();
            },
            updateSort(sort, type) {
                this.filter.sorting = sort;
                this.filter.sorting_type = type;
                this.getRecords();
            },
            selectAll(e) {
                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    el.checked = e.target.checked;
                });
            },
            clearCheckboxes() {
                let elements = document.querySelectorAll('input[type="checkbox"]');
                elements.forEach((el) => {
                    el.checked = false;
                });
            },
            refreshCodes() {
                this.search = null
                this.getRecords();
            },
            clearGroup() {

                let codes = [];

                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    if (el.checked) codes.push(el.name);
                });

                if (!codes.length) return;

                this.modalData = {
                    codes: codes,
                    type: 'clearGroup',
                    header: 'Вы уверены?',
                    body: 'Хотите добавить в игнорирование выбранные продукты?',
                    acceptBtnText: 'Да',
                    cancelBtnText: 'Нет'
                };
            }
            ,
            async acceptModal() {
                switch (this.modalData.type) {
                    case 'clearGroup':
                        let {data: data1} = await api.store('/egk/updateProduct', {
                            codes: this.modalData.codes,
                            type: 'addToIgnore'
                        })
                        this.onModalClose();
                        if (data1.success) {
                            this.Toast.fire({
                                type: 'success',
                                title: 'Сохранено'
                            })
                            this.getRecords(this.paginator.current_page);
                        } else {
                            this.Toast.fire({
                                type: 'warning',
                                title: 'Ошибка ' + data1.message
                            })
                        }
                        break;

                    case 'moderate':
                        let {data: data2} = await api.store('/egk/updateProduct', {
                            codes: this.modalData.codes,
                            type: 'moderate'
                        })
                        this.onModalClose();
                        if (data2.success) {
                            this.Toast.fire({
                                type: 'success',
                                title: 'Сохранено'
                            })
                            this.getRecords(this.paginator.current_page);
                        } else {
                            this.Toast.fire({
                                type: 'warning',
                                title: 'Ошибка ' + data2.message
                            })
                        }
                        break;

                    default:
                        this.modalData = null;
                        return;
                        break;
                }
                this.modalData = null;
            }
            ,
            onModalClose() {
                this.modalData = null;
            }
            ,
            searchSubmit(e) {
                e.preventDefault();
                e.stopPropagation();
                this.paginator.current_page = 1;
                this.getRecords(1);
            }
            ,
            async getRecords(page = null) {
                this.clearCheckboxes();
                this.records = null;
                let {data: r_data} = await api.store('/egk/getCodes?page=' + page + '&search=' + this.search + '&type=grouped', {
                    filter: this.filter
                });
                const {data, ...pagination} = r_data.records;
                this.paginator = pagination;
                this.records = data;
                this.parser = r_data.parser;

                if (this.$refs.Pagination && !page)
                    this.$refs.Pagination.selected = 1;
            }
            ,
        }
    }
</script>

<style scoped>
    .search_row {
        padding-bottom: 15px;
    }

    .inline {
        display: inline;
    }

    .m-b-0 {
        margin-bottom: 0;
    }

    td p {
        margin-bottom: 2px;
    }

    .m-b-10 {
        margin-bottom: 10px;
    }
</style>
